import { isEmpty } from '../utils/is-empty.mjs';
import { removeMarks } from '../utils/marks.mjs';

function withEmptyClearFormatting(editor) {
  const { onChange } = editor;
  editor.onChange = (options) => {
    if (isEmpty(editor, editor.children)) {
      removeMarks(editor);
    }
    onChange(options);
  };
  return editor;
}

export { withEmptyClearFormatting };
//# sourceMappingURL=empty-clear-formatting.mjs.map
